import { render, staticRenderFns } from "./veStuChangeZy.vue?vue&type=template&id=5c3cd0ba&scoped=true"
import script from "./veStuChangeZy.vue?vue&type=script&lang=js"
export * from "./veStuChangeZy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3cd0ba",
  null
  
)

export default component.exports